module.exports = __webpack_public_path__ + "img/pic2.5542dbe2.png";